import { isMobile } from "react-device-detect";
import MicrophoneIconWhite from "../../../assets/icons/header-icons/microphone-icon-white.svg";
import NewsPartitionIcon from "../../../assets/icons/header-icons/news-partition-icon.svg";
import SportsBookPromotionImage from "../../../assets/images/sportsbook_banner.png";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { EventDTO, getInplayEvents, getUpcomingEvents, setCompetition, setCompetitionThunk, setEventType, setExchEvent, SPORTS_BOOK_ROUTE, SPORTS_MAP, useAppDispatch, useAppSelector } from "@hypexone/uicore";
import Announcement from "../../components/header/Announcement";
import Button from "./Button/Button";
import { appNavigationConstants, appNavigationConstants_Mobile, appNavigationConstants_sports } from "../../../utils/constants/header.constants";
import Cricket from "../../../assets/images/sports_svgs/cricket_svg.svg"
import Football from "../../../assets/images/sports_svgs/football_svg.svg"
import Tennis from "../../../assets/images/sports_svgs/tennis_svg.svg"
import Casino from "../../../assets/images/sports_svgs/casino_svg.png"
import HorseRacing from "../../../assets/images/sports_svgs/horse_racing_svg.svg"
import GreyhoundRacing from "../../../assets/images/sports_svgs/greyhound_svg.png"
import Binary from "../../../assets/images/sports_svgs/binary_svg.png"
import Politics from "../../../assets/images/sports_svgs/politics_svg.png"
import Basketball from "../../../assets/images/sports_svgs/basketball_svg.png"
import Baseball from "../../../assets/images/sports_svgs/baseball_svg.png"
import TableTennis from "../../../assets/images/sports_svgs/tableTennis_svg.png"
import Volleyball from "../../../assets/images/sports_svgs/volleyball_svg.png"
import IceHockey from "../../../assets/images/sports_svgs/icehockey_svg.png"
import SportsBook from "../../../assets/images/sports_svgs/sportsbook_svg.svg"
import { IoSearch } from "react-icons/io5";
import { useEffect, useState } from "react";
import { PiLessThanBold } from "react-icons/pi";
import { IoIosClose, IoIosSearch } from "react-icons/io";
import { getCompetitionSlug } from "../../../utils/hooks/event.hooks";


interface NewsAndPromotionsProps {
  hasPromotions?: boolean;
  hasExchAndSportsbook?: boolean;
}

const NewsAndPromotions: React.FC<NewsAndPromotionsProps> = ({
  hasPromotions,
  hasExchAndSportsbook,
}) => {
  
  const [showSearch, setShowSearch] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState<EventDTO[]>([]);
  const bgGradient = "bg-gradient-to-b from-blue10 to-blue11";
  const { langData } = useAppSelector((state) => state.cms);
  const location = useLocation();
  const { events: catalogEvents, selectedEventType } = useAppSelector(
    (state) => state.catalog
  );
    const { allowedConfig } = useAppSelector((state) => state.common);
   const inplayEvents = getInplayEvents(catalogEvents, allowedConfig);
    const upcomingEvents = getUpcomingEvents(catalogEvents, allowedConfig);
  const handleNavLinkClick = (title: string) => {
    dispatch(setCompetition({ id: "", name: "", slug: "" }));
    const sport = SPORTS_MAP.get(title);
    if (sport) {
      dispatch(setEventType(sport));
    }
  };
  const sportImages: { [key: string]: string } = {
    cricket: Cricket,
    football: Football,
    tennis: Tennis,
    casino: Casino,
    horseracing: HorseRacing,
    greyhoundracing: GreyhoundRacing,
    binary: Binary,
    politics: Politics,
    basketball: Basketball,
    baseball: Baseball,
    tabletennis: TableTennis,
    volleyball: Volleyball,
    icehockey: IceHockey,
    sportsbook: SportsBook
  };
  const handleEventChange = (event: EventDTO) => {
    dispatch(
      setCompetitionThunk({
        id: event.competitionId,
        name: event.competitionName,
        slug: getCompetitionSlug(event.competitionName),
      })
    );
    dispatch(
      setExchEvent({
        id: event.eventId,
        name: event.eventName,
        slug: event.eventSlug || "",
      })
    );
  };
   useEffect(() => {
      if (!searchQuery.trim()) {
        setSearchResults([]);
        return;
      }
  
      const combinedEvents = [...inplayEvents, ...upcomingEvents];

  const filtered: EventDTO[] = [];
  combinedEvents.forEach((eventObj) => {
    eventObj.events.forEach((event) => {
      if (event.eventName.toLowerCase().includes(searchQuery.toLowerCase())) {
        filtered.push(event);
      }
    });
  });

  setSearchResults(filtered);

    }, [searchQuery]);

  const normalizeTitle = (title: string) =>
    title?.toLowerCase().replace(/\s+/g, "");

  return (
    <>
      {showSearch && (
        <div className="sm:hidden fixed top-0 left-0 w-full bg-white px-3 py-3 flex items-center z-50 ">
          <PiLessThanBold className="w-4 h-4 mr-2 cursor-pointer"
            onClick={() => {
              setShowSearch(false)
              setSearchQuery("")
              setSearchResults([])
            }} />

          <input
            type="text"
            placeholder="Search events..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="flex-1 px-3 py-2 rounded-md border border-gray-300 outline-none"
          />
          <IoIosClose className="w-8 h-8 text-[grey]  cursor-pointer" onClick={() => setSearchQuery("")} />
          <IoIosSearch className="w-6 h-6 " />
        </div>
      )}
      {searchResults.length > 0 && (
        <div className="sm:hidden fixed top-[56px] left-0 w-full bg-white z-40 h-[70vh] overflow-auto ">
          {searchResults.map((event, index) => (
            <div key={index} className="px-4 py-2 border-b border-gray-200 text-sm" onClick={() => {
              handleEventChange(event);
              const providerName = event.providerName || "";
              const catId = event.catId || "";
              const loggedIn = true;
              const competitionName = event.competitionName || "";
              const eventSlug = event.eventSlug || "";
              const sportId = event.sportId || "";
              const competitionId = event.competitionId || "";
              const eventId = event.eventId || "";
              navigate(
                providerName?.toLowerCase() === "sportradar" &&
                  catId === "SR VIRTUAL"
                  ? loggedIn
                    ? `/exchange_sports/virtuals/${selectedEventType.slug
                    }/${getCompetitionSlug(
                      competitionName
                    )}/${eventSlug}/${btoa(
                      `${sportId}:${competitionId}:${eventId}`
                    )}`
                    : "/login"
                  : `/exchange_sports/${selectedEventType.slug
                  }/${getCompetitionSlug(
                    competitionName
                  )}/${eventSlug}/${btoa(
                    `${sportId}:${competitionId}:${eventId}`
                  )}`
              );
            }}>
              <div className="text-[#2789ce] font-medium">
                {new Date(event.openDate).toLocaleDateString("en-GB")}
              </div>
              <div className="mt-1">
                <span className="text-[#777] mr-2">
                  {new Date(event.openDate).toLocaleTimeString("en-GB", {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </span>
                <span className="text-[#2789ce] text-[17px] font-bold">{event.eventName}</span>
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="flex flex-col md:gap-[1px] overflow-hidden">
        <div
          className={`flex items-center px-2 gap-2 text-xs ${bgGradient}`}
        >
          <div className="flex items-center gap-2 mr-4">
            <img src={MicrophoneIconWhite} alt="mic-icon" className="h-[15px]" />
            <div className="text-white">News</div>
            <img src={NewsPartitionIcon} alt="right-icon" className="h-full" />
          </div>

          <div className="text-white w-full md:w-full">
            <Announcement />
          </div>
        </div>

        {(location.pathname.includes("/sports_event/casino") || hasPromotions) && (
          <div className="flex flex-col w-full">
            <img
              src={SportsBookPromotionImage}
              alt="sportsBook"
              className="object-content w-full "
            />

            {(isMobile || hasExchAndSportsbook) && (
              <div className="flex text-[14px] justify-center w-full bg-gradient-to-b from-blue25 to-blue26 text-sm font-bold py-1.5 gap-2">
                <Button className="bg-blue4 px-4 py-2
 text-white  md:py-2 rounded-[10px]">
                  EXCHANGE
                </Button>

                <Button
                  className="border px-4 text-[14px] py-2
 border-blue4 md:py-2 rounded-[10px] text-blue4"
                  onClick={() => navigate(SPORTS_BOOK_ROUTE)}
                >
                  SPORTSBOOK
                </Button>
              </div>
            )}

          </div>
        )}

      {(location.pathname.includes("/sports_event")||location.pathname.startsWith("/exchange_sports/sports"))  && (
  <div className="relative">
    {/* Search icon fixed to right */}
    <IoSearch
      className="w-10 h-10 p-1 text-white bg-gradient-to-b from-blue10 to-blue11 absolute right-[1px] top-1/2 -translate-y-1/2 z-10"
      onClick={() => setShowSearch(true)}
    />

    {/* Scrollable nav */}
    <div className="flex hide-scrollbar bg-gradient-to-b from-blue10 to-blue11 overflow-x-scroll pr-10">
      {appNavigationConstants_sports.map(({ title, navigationUrl }, index) => (
        <div key={title} className="relative">
          <NavLink
            to={navigationUrl}
            className={({ isActive }) =>
              `flex justify-center items-end mt-2 gap-[2px] font-[400] px-7 py-2 text-white text-[14px] whitespace-nowrap
              ${isActive ? "bg-black1 border-x border-t border-white rounded-t-[8px]" : ""}
              ${title === "Casino" || title === "Int Casino" ? "animate-highlight rounded-t-lg" : ""} font-sans text-[13px] font-[600]`
            }
            onClick={() => handleNavLinkClick(title)}
          >
            {isMobile && (
              <img
                src={sportImages[normalizeTitle(title)] || ""}
                alt={title}
                className="w-5 h-5 object-contain invert"
              />
            )}
            {title}
          </NavLink>

          {/* NEW badge */}
          {title === "Binary" && (
            <div className="absolute top-[1rem] right-0 bg-red-500 text-white text-[8px] px-[2px] flex items-center justify-center blink rounded">
              NEW
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
)}







      </div>
    </>

  );
};

export default NewsAndPromotions;
